import React, { Component } from "react";
import { Header, Segment } from "semantic-ui-react";

class CreditCards extends Component {
  render() {
    return (
      <Segment basic>
        <Header as="h2">
          <a href="https://login.netbanx.com/office/" target="_blank" rel="noopener noreferrer">
            NetBanx (Paysafe)
          </a>
          <Header.Subheader>
            Our preferred credit card processor. You may login here to manage
            your credit card payments.
          </Header.Subheader>
        </Header>
        <Header as="h3">
          Paysafe VIP Support
        </Header>
        <ul>
          <li><a href="tel:18448626925">1-(844)-862-6925</a></li>
          <li><a href="mailto:viptechnicalsupport@paysafe.com">VIP Technical Support Email</a></li>
        </ul>
        <Header as="h2">
        Reset Handpoint Device
        </Header>
        <ol>
          <li>Press the red "C" button followed by the yellow arrow</li>
          <li>When prompted for password enter "746723" and press "OK"</li>
          <li>Using the arrows select "Config" and press "OK"</li>
          <li>Using the arrows select "Reset Flash" and press "OK"</li>
          <li>The screen will flash, when the menu returns select "Save and Reset"</li>
          <li>The device will restart. Next time you start the app the device will download the latest firmware</li>
        </ol>
        <Header as="h2">
          <a href="https://gateway.itstgate.com/" target="_blank" rel="noopener noreferrer">
            BridgePay
          </a>
          <Header.Subheader>
            Our previous credit card processor. You may login here to manage
            your credit card payments.
          </Header.Subheader>
        </Header>
      </Segment>
    );
  }
}

export default CreditCards;
